import { create } from "zustand";
import type { UpgradeContext } from "@/components/ui/upgrade-to-growth-modal";
import type { UserRole } from "@/modules/membership";

interface UpgradeModalState {
	isOpen: boolean;
	title: string;
	message: string;
	context: UpgradeContext;
	workspaceId: string | undefined;
	reviewLimit: number | undefined;
	userRole: UserRole | undefined;
	onMaybeLaterCallback: (() => void) | undefined;
}

interface UpgradeModalActions {
	openUpgradeModal: (options: { title?: string; message?: string; context?: UpgradeContext; workspaceId?: string; reviewLimit?: number; userRole?: UserRole; onMaybeLater?: () => void }) => void;
	closeUpgradeModal: () => void;
	maybeLater: () => void;
}

export const useUpgradeModalStore = create<UpgradeModalState & UpgradeModalActions>((set) => ({
	isOpen: false,
	title: "",
	message: "",
	context: "general",
	workspaceId: undefined,
	reviewLimit: undefined,
	userRole: undefined,
	onMaybeLaterCallback: undefined,

	openUpgradeModal: ({ title, message, context = "general", workspaceId, reviewLimit, userRole, onMaybeLater }) =>
		set({
			isOpen: true,
			title: title || "",
			message: message || "",
			context,
			workspaceId,
			reviewLimit,
			userRole,
			onMaybeLaterCallback: onMaybeLater,
		}),

	closeUpgradeModal: () =>
		set({
			isOpen: false,
			onMaybeLaterCallback: undefined,
		}),

	maybeLater: () => {
		const callback = useUpgradeModalStore.getState().onMaybeLaterCallback;
		set({
			isOpen: false,
			onMaybeLaterCallback: undefined,
		});
		callback?.();
	},
}));
